import TokensService from '@omni/kit/services/TokensService';

import Environment from '../../Environment';
import BaseService, {
  IFilter,
  IHttpResponse,
  IUri,
  buildUrl,
} from '../BaseService';

const RESOURCE = 'favorites';

interface IAction {
  is_home: boolean;
  is_media_search_enabled?: boolean;
  appkey: string;
  handler: string;
}
interface IFavorite {
  images: any;
  sapid: string;
  title: string;
  actions?: IAction[];
}

interface IGetFavorites extends IUri {
  token?: string;
  filters: IFilter[];
  getFromCache: boolean;
}

interface IGetFavoritesResponse extends IHttpResponse {
  body?: {
    items: IFavorite[];
  };
}

export default async function ({
  token,
  getFromCache,
  ...buildUrlProps
}: IGetFavorites): Promise<IGetFavoritesResponse> {
  const url = buildUrl({
    host: Environment.feedsService,
    resource: RESOURCE,
    ...buildUrlProps,
  });

  if (!token?.length) {
    token = await TokensService.getGuestToken();
  }

  return BaseService.Get({
    url,
    token,
    getFromCache,
  });
}
